import React from "react";
import TenantAdminPage from "../pl/TenantAdminPage";

export default function TenantAdminSettingsPage() {
  return <TenantAdminPage mode="settings" />;
}
